import { Box, Container, Heading, Text, Image, Button, Link } from '@chakra-ui/react';
import mwoowGif from '../assets/images/gif/mwoow.gif';
import SocialLinks from '../components/SocialLinks';
const TechnicalMaintenance = () => {
	return (
		<Box
			display="flex"
			alignItems="center"
			justifyContent="center"
			height="100vh"
			bg="#FFF8F3"
		>
			<Container
				centerContent
				bg="white"
				borderRadius="md"
				boxShadow="md"
				p={10}
				maxW="lg"
				textAlign="center"
			>
				<Heading as="h1" mb={4} size="xl" color="#FF684B">
					We are currently undergoing maintenance
				</Heading>
				<Image src={mwoowGif} maxH="250px"></Image>
				<Text mb={6} fontSize="lg" color="gray.600">
					We apologize for the inconvenience. We are improving our site and will be back soon. Please check back later.
				</Text>
				<SocialLinks />
				<Text pt={2}>Come and celebrate Scroll Anniversary with us! 🎉 </Text>
				<Text>Don’t miss out on the fun—join the game and win prizes! 🎮 </Text>
				<Button
					mt={2}
					colorScheme="orange"
					as={Link}
					isExternal
					href="https://game.scrollstat.xyz/"
					textDecoration="none" // Убираем подчеркивание
				>
					Play Game
				</Button>
			</Container>
		</Box>
	);
};

export default TechnicalMaintenance;
